/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import props from './check-tag-props.js';
import { renderContent } from '../utils/render-tnode.js';
import { emitEvent } from '../utils/event.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var classPrefixMixins = getClassPrefixMixins("tag");
var _CheckTag = mixins(classPrefixMixins).extend({
  name: "TCheckTag",
  props: _objectSpread({}, props),
  computed: {
    tagClass: function tagClass() {
      var _ref;

      return ["".concat(this.componentName), "".concat(this.componentName, "--check"), "".concat(this.componentName, "--default"), this.commonSizeClassName[this.size], (_ref = {}, _defineProperty(_ref, "".concat(this.componentName, "--checked"), !this.disabled && this.checked), _defineProperty(_ref, "".concat(this.classPrefix, "-is-disabled"), this.disabled), _defineProperty(_ref, "".concat(this.componentName, "--disabled"), this.disabled), _ref)];
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      if (!this.disabled) {
        emitEvent(this, "click", {
          e: e
        });
        emitEvent(this, "change", !this.checked);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var tagContent = renderContent(this, "default", "content");
    return h("span", {
      "class": this.tagClass,
      "on": {
        "click": this.handleClick
      }
    }, [tagContent]);
  }
});

export { _CheckTag as default };
//# sourceMappingURL=check-tag.js.map
